import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { find } from 'lodash';

import api from 'core/utils/api';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  userId: PropTypes.string,
};

const defaultProps = {
  onBlur: () => { },
  userId: null,
};

const renderLabel = user => `${user.first_name} ${user.last_name}`;

class UserLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: null,
      users: [],
    };

    this.handleBlur = this.handleBlur.bind(this);
    this.loadUsers = this.loadUsers.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setInitialUser = this.setInitialUser.bind(this);
  }

  componentDidMount() {
    this.loadUsers();
  }

  setInitialUser() {
    const { userId } = this.props;
    if (!userId) { return; }

    const found = find(this.state.users, { id: userId });
    this.setState({ user: found });
  }

  handleBlur() {
    const { onBlur } = this.props;
    if (onBlur) { onBlur(); }
  }

  loadUsers() {
    api
      .get('/users')
      .then((res) => {
        this.setState({
          users: res.data.users,
          loading: false,
        }, () => {
          this.setInitialUser();
        });
      });
  }

  handleChange(user) {
    this.setState({ user }, () => {
      this.props.onChange(user);
    });
  }

  render() {
    const { loading, users, user } = this.state;

    return (
      <Select
        value={user}
        isLoading={loading}
        isClearable
        options={users}
        onChange={this.handleChange}
        getOptionLabel={option => renderLabel(option)}
        getOptionValue={option => option.id}
        onBlur={this.handleBlur}
      />
    );
  }
}

UserLookup.propTypes = propTypes;
UserLookup.defaultProps = defaultProps;

export default UserLookup;



// WEBPACK FOOTER //
// ./src/components/UserLookup.js